import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Figure, ScrollAnimationParent } from '@studiometa/ui';
import { isDev } from './config.js';
import Header from './organisms/Header.js';
import StickyWidget from './molecules/StickyWidget.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./molecules/Video.js').default>>
 *     Accordion: Array<Promise<import('./molecules/Accordion.js').default>>
 *     Slider: Array<Promise<import('./molecules/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Figure,
      Header,
      Action,
      ScrollAnimationParent,
      StickyWidget,
      Slider: (app) => importWhenVisible(() => import('./molecules/Slider.js'), 'Slider', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.$log('mounted 🎉');
  }
}

export default createApp(App, document.body);
